
const ligacao = {
    namespaced: true,
    state: () => ({        
        menu_id: null,
        item_id: null,
        cliente_id: null,
    }),
    mutations: {
        setRoute(state, route) {
            state.route = route;
        },
        setMenuId(state, id) {
            state.menu_id = id;
        },
        setClienteId(state, id) {
            state.cliente_id = id;
        },
        setItemId(state, id) {
            state.item_id = id;
        },
    },

}


export default ligacao;